import { Stands } from '../Stands';
import { AppConfigs } from './AppConfigs/AppConfigs';

export const services = {
	clientShowcaseApi: 'clientShowcaseApi',
	clientAuthApi: 'clientAuthApi',
	clientAppFormApi: 'clientAppFormApi',
	clientProfileApi: 'clientProfileApi',
	fileLoadApi: 'fileLoadApi',
	clientOrderApi: 'clientOrderApi',
};

const gateway = {
	[Stands.test]: 'https://api.efrtest.ru',
	[Stands.cert]: 'https://api.efrcert.ru',
	[Stands.prod]: 'https://api.efr.ru',
};

export const efrBotPaths = [
	'/',
	'/showcaseCreditCards',
	'/showcaseCreditCashes',
];

export const appEfrConfig = new AppConfigs<typeof services>({
	servicesHosts: Object.fromEntries(
		Object.keys(services).map((key) => [key, gateway]),
	) as Record<keyof typeof services, typeof gateway>,
	appHostName: 'efr',
});
export type AppEfrConfig = AppConfigs<typeof services>;
